import React from "react";
import InputGroup from "src/business-types/grocery/layouts/setting/customer/InputGroup";

interface Props {
  value: string;
  error: boolean;
  onChange: (value: string) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const CategoryNameField: React.FC<Props> = ({
  value,
  error,
  onChange,
  onKeyPress,
  disabled,
}) => {
  return (
    <div className="flex flex-col gap-1">
      <InputGroup
        label="Category name"
        type="text"
        name="categoryName"
        value={value}
        mandatory
        disabled={disabled}
        onKeyDown={onKeyPress}
        onChange={(_, val) => onChange(val)}
      />

      {error && (
        <span className="text-xs text-red-600">
          Category name is required
        </span>
      )}
    </div>
  );
};

export default CategoryNameField;
